import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NortonEmpower from "@/pages/NortonEmpower";

function App() {
  return (
    <div className="App bg-background min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<NortonEmpower />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
